import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["monthNames", "weekdayNames", "monthsToDisplay", "stacked", "disabledDates", "interactiveDisabledDates"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import subDays from 'date-fns/subDays';
import Dayzed from 'dayzed';
import { Flex, Box } from "../";
import CalendarNav from "./components/CalendarNav";
import CalendarMonth from "./components/CalendarMonth";

var DatePicker = function DatePicker(_ref) {
  var monthNames = _ref.monthNames,
      weekdayNames = _ref.weekdayNames,
      monthsToDisplay = _ref.monthsToDisplay,
      stacked = _ref.stacked,
      disabledDates = _ref.disabledDates,
      interactiveDisabledDates = _ref.interactiveDisabledDates,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Dayzed, _extends({}, rest, {
    monthsToDisplay: monthsToDisplay,
    render: function render(_ref2) {
      var calendars = _ref2.calendars,
          getBackProps = _ref2.getBackProps,
          getForwardProps = _ref2.getForwardProps,
          getDateProps = _ref2.getDateProps;
      if (!calendars.length) return null;
      return /*#__PURE__*/React.createElement(Box, {
        position: "relative"
      }, /*#__PURE__*/React.createElement(CalendarNav, {
        prevProps: getBackProps({
          calendars: calendars
        }),
        nextProps: getForwardProps({
          calendars: calendars
        })
      }), /*#__PURE__*/React.createElement(Flex, {
        flexWrap: "wrap"
      }, calendars.map(function (calendar) {
        return /*#__PURE__*/React.createElement(CalendarMonth, {
          key: "".concat(calendar.month).concat(calendar.year),
          monthsToDisplay: monthsToDisplay,
          monthName: monthNames[calendar.month],
          month: calendar.month,
          year: calendar.year,
          stacked: stacked,
          weekdayNames: weekdayNames,
          weeks: calendar.weeks,
          getDateProps: getDateProps,
          disabledDates: disabledDates,
          interactiveDisabledDates: interactiveDisabledDates
        });
      })));
    }
  }));
};

DatePicker.defaultProps = {
  monthsToDisplay: 1,
  firstDayOfWeek: 1,
  stacked: false,
  minDate: subDays(new Date(), 1),
  disabledDates: [],
  interactiveDisabledDates: false,
  monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
};
DatePicker.propTypes = _objectSpread(_objectSpread({}, Dayzed.propTypes), {}, {
  monthsToDisplay: PropTypes.number,
  firstDayOfWeek: PropTypes.number,
  stacked: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  disabledDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  interactiveDisabledDates: PropTypes.bool,
  monthNames: PropTypes.arrayOf(PropTypes.string),
  weekdayNames: PropTypes.arrayOf(PropTypes.string)
});
export default DatePicker;